import React, { FC, useEffect, useState } from 'react';
import { FormControl, FormHelperText, InputLabel, Select } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { ProductCategory } from 'src/interfaces/api/Product';
import { getJsonResponse } from 'src/utils/ApiUtils';
import useAuth from 'src/hooks/api/useAuth';
import api from 'src/config/api';

interface Props {
  value?: number;
  error?: boolean;
  helperText?: string;
  className?: any;
  fullWidth?: boolean;
  onChange: (event: React.ChangeEvent<{ name?: string; value: unknown }>) => void;
}

const LegacyProductCategorySelect: FC<Props> = React.forwardRef<any, Props>(
  ({ onChange, className, value, helperText, ...props }, ref) => {
    const [productCategories, setProductCategories] = useState<ProductCategory[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string>();
    const { fetch } = useAuth();

    const getCategories = async (): Promise<ProductCategory[]> => {
      const { endpoint, ...options } = api.legacyProduct.getCategories();

      const response = await fetch(endpoint, options);

      try {
        const json = await getJsonResponse<{ data: { productReferenceCategories: ProductCategory[] } }>(response);
        return json.data.productReferenceCategories.sort((categoryA: ProductCategory, categoryB: ProductCategory) =>
          categoryA.name.localeCompare(categoryB.name)
        );
      } catch (e) {
        throw new Error(e.message);
      }
    };

    useEffect(() => {
      getCategories()
        .then((data) => {
          setProductCategories(data);
          setLoading(false);
        })
        .catch((e) => {
          setError(e.message);
          setLoading(false);
        });
    }, []);

    if (loading) {
      return <Skeleton height={50} />;
    }

    if (error) {
      return <div style={{ color: '#f44336' }}>{error}</div>;
    }

    return (
      <FormControl ref={ref} className={className} variant='outlined' error={props.error} {...props}>
        <InputLabel>Catégorie</InputLabel>
        <Select native value={value || ''} onChange={onChange} label='Catégorie'>
          <option value='' />
          {productCategories.map((productCategory, key) => (
            <option key={key} value={productCategory.id}>
              {productCategory.name}
            </option>
          ))}
        </Select>
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    );
  }
);

export default React.memo(LegacyProductCategorySelect);
